import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Tier.Save.IRequest;
type Response = Api.Core.Tier.Save.IResponse;
type Headers = Api.Core.Tier.Save.IHeaders;
const url = '/api/ProductManagement/Tier';
export default async function tierSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
